module.exports = __webpack_public_path__ + "static/img/bg-tr.43799559.webp";